'use client';

export type Vacancy = {
  id: string;
  title: string;
  location: string;
  type: string;
  summary: string;
  responsibilities: string[];
  requirements: string[];
};

export const VACANCIES: Vacancy[] = [
  {
    id: 'sales-representative',
    title: 'Sales Representative',
    location: 'Dubai • Remote-friendly',
    type: 'Full-time',
    summary:
      'Own pipeline, nurture relationships, and help marine energy teams adopt modern software. You’ll work closely with product and leadership to shape pilots, articulate value, and make onboarding effortless. We sell with transparency and long-term partnerships in mind, not pressure tactics. Expect collaboration, clear goals, and the freedom to do your best work.',
    responsibilities: [
      'Prospect and qualify marine energy brokers, traders, and suppliers',
      'Run discovery, product walkthroughs, and value mapping',
      'Coordinate pilots and close opportunities with clear next steps',
      'Partner with product to capture customer feedback and insights',
      'Maintain impeccable pipeline hygiene and forecasting discipline',
      'Document learnings to continuously refine our messaging and ICP',
      'Collaborate with marketing on targeted outreach and narratives',
      'Engage executive stakeholders with crisp ROI and timeline clarity',
      'Champion customer success handover for smooth activations',
      'Represent the brand at industry events and remote demos',
      'Track competitive signals and share actionable intelligence',
      'Contribute to playbooks that scale repeatable, ethical sales',
    ],
    requirements: [
      'Experience in bunkering or maritime SaaS is a strong plus',
      'Fluent written and spoken English; additional languages are a bonus',
      'Comfortable with structured CRM workflows and pipeline hygiene',
      'Bias for clarity, speed, and honest pricing conversations',
      'Excellent discovery skills and the ability to map pain to value',
      'Confident communicator across operators and senior leadership',
      'Organized, self-directed, and reliable in remote settings',
      'Familiarity with modern tooling (CRM, Loom, Notion, Google Workspace)',
      'Ability to navigate complex stakeholder environments',
      'Strong writing — concise, persuasive, and customer-centric',
    ],
  },
];
